export default "__VITE_ASSET__BQfLmPzK__"